/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_BracketInputs */

const th_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สายการแข่งขัน`)
};

const en_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bracket`)
};

const ja_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トーナメント表`)
};

const zh_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对阵表`)
};

const es_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuadro`)
};

const pt_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaveamento`)
};

const id_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagan`)
};

const fr_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau`)
};

const tl_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bracket`)
};

const vi_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhánh đấu`)
};

const ko_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대진표`)
};

const de_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnierbaum`)
};

const ru_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сетка`)
};

const tr_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleme tablosu`)
};

const it_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabellone`)
};

const pl_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drabinka`)
};

const uk_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сітка`)
};

const hi_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉ`)
};

const ar_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جدول الأدوار`)
};

const ms_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carta`)
};

const bn_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ড্র`)
};

const zh_tw2_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`對戰表`)
};

const zh_hk2_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`對戰表`)
};

const ur_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ڈرا`)
};

const fa_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جدول حذفی`)
};

const sw_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chati ya mtoano`)
};

const nl_tab_bracket = /** @type {(inputs: Tab_BracketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema`)
};

/**
* | output |
* | --- |
* | "Bracket" |
*
* @param {Tab_BracketInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_bracket = /** @type {((inputs?: Tab_BracketInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_BracketInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_bracket(inputs)
	if (locale === "ja") return ja_tab_bracket(inputs)
	if (locale === "zh") return zh_tab_bracket(inputs)
	if (locale === "es") return es_tab_bracket(inputs)
	if (locale === "pt") return pt_tab_bracket(inputs)
	if (locale === "id") return id_tab_bracket(inputs)
	if (locale === "fr") return fr_tab_bracket(inputs)
	if (locale === "tl") return tl_tab_bracket(inputs)
	if (locale === "vi") return vi_tab_bracket(inputs)
	if (locale === "ko") return ko_tab_bracket(inputs)
	if (locale === "de") return de_tab_bracket(inputs)
	if (locale === "ru") return ru_tab_bracket(inputs)
	if (locale === "tr") return tr_tab_bracket(inputs)
	if (locale === "it") return it_tab_bracket(inputs)
	if (locale === "pl") return pl_tab_bracket(inputs)
	if (locale === "uk") return uk_tab_bracket(inputs)
	if (locale === "hi") return hi_tab_bracket(inputs)
	if (locale === "ar") return ar_tab_bracket(inputs)
	if (locale === "ms") return ms_tab_bracket(inputs)
	if (locale === "bn") return bn_tab_bracket(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_bracket(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_bracket(inputs)
	if (locale === "ur") return ur_tab_bracket(inputs)
	if (locale === "fa") return fa_tab_bracket(inputs)
	if (locale === "sw") return sw_tab_bracket(inputs)
	if (locale === "nl") return nl_tab_bracket(inputs)
	return en_tab_bracket(inputs)
});